import { OverlayRef, Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, ComponentRef, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { ModalSocialEventComponent, ModalSocialEventData } from '../modal-social-event/modal-social-event.component';
import ModalActionType from '../modal-social-event/ModalActionType';

@Injectable({
  providedIn: 'root',
})
export class ModalSocialEventService {
  private overlay = inject(Overlay);
  private dialog = inject(MatDialog);

  private overlayRef?: OverlayRef;
  private portalRef?: ComponentPortal<ModalSocialEventComponent>;
  private ref?: ComponentRef<ModalSocialEventComponent>;

  public open(data: ModalSocialEventData): Subject<ModalActionType> {
    this.overlayRef = this.overlay.create({
      panelClass: 'modal-social-event-overlay',
      width: '100%',
      // height: '100%'
    });

    this.portalRef = new ComponentPortal(ModalSocialEventComponent);
    this.ref = this.overlayRef.attach(this.portalRef);

    this.ref.instance.title = data.title;
    this.ref.instance.message = data.message ?? '';
    this.ref.instance.messageBold = data.messageBold;
    this.ref.instance.cancelButtonTitle = data.cancelButtonTitle;
    this.ref.instance.confirmButtonTitle = data.confirmButtonTitle;
    this.ref.instance.hideModalButtonTitle = data.hideModalButtonTitle;
    this.ref.instance.showModalButtonTitle = data.showModalButtonTitle;
    this.ref.instance.showContent = data.showContent;
    this.ref.instance.warningMessage = data.warningMessage ?? '';
    this.ref.instance.isPresenter = data.isPresenter;

    this.ref.instance.eventSubject.subscribe(() => {
      this.close();
    });

    return this.ref.instance.eventSubject;
  }

  public close(): void {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.portalRef = undefined;
      this.overlayRef = undefined;
      this.ref = undefined;
    }
  }
}
